import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { DropDownListModule } from "@progress/kendo-angular-dropdowns";
import { LayoutModule } from "@progress/kendo-angular-layout";
import { PopoverModule } from "ngx-popover";
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DownloadExcelModule } from "../../../dms/layout/modals/download-excel/download-excel.module";
import { GenericModalModule } from "../../../dms/layout/modals/generic-modal/generic-modal.module";
import { ModalMailModule } from "../../../dms/layout/modals/modal-mail/modal-mail.module";
import { ModalPhoneModule } from "../../../dms/layout/modals/modal-phone/modal-phone.module";
import { DeleteCustomerModalModule } from "../../../dms/modulos/general/componentes/gestion-terceros/modals/delete-customer-modal/delete-customer-modal.module";
import { DesactivarCustomerModalModule } from "../../../dms/modulos/general/componentes/gestion-terceros/modals/desactivar-customer-modal/desactivar-customer-modal.module";
import { CanBeDeleteService } from "../../../dms/modulos/general/componentes/gestion-terceros/servicios/can-be-delete.service";
import { AdjuntarDocumentosService } from "../../../shared/components/adjuntar-documentos/adjuntar-documentos.service";
import { PipesModule } from "../../../shared/_pipes/pipes.module";
import { DirectivesModule } from "../../directives/directives.module";
import { InformationBoxModule } from "../InformationBox/information-box.module";
import { AdministrativeCentersModule } from "./administrative-centers/administrative-centers.module";
import { CommunicationsModule } from "./communications/communications.module";
import { ContactInformationModule } from "./contact-information/contact-information.module";
import { ContactsModule } from "./contacts/contacts.module";
import { GestionTercerosRegisterComponent } from "./gestion-terceros-register.component";
import { GestionModule } from "./gestion/gestion.module";
import { IdentificationDataModule } from "./identification-data/identification-data.module";
import { TabVehiclesModule } from "./tab-vehicles/tab-vehicles.module";
import { SmsService } from "../../../dms/modulos/general/componentes/gestion-terceros/servicios/sms.service";
import { EmailService } from "../../../dms/modulos/general/componentes/gestion-terceros/servicios/email.service";
import { ModalOrdersModule } from "../../../dms/layout/modals/modal-orders/modal-orders.module";
import { ORCustomerVehicleService } from "../../services/or-customer-vehicle.service";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        PipesModule,
        DirectivesModule,
        ModalPhoneModule,
        GenericModalModule,
        PopoverModule,
        DropDownListModule,
        AutoCompleteModule,
        LayoutModule,
        InformationBoxModule,
        TabVehiclesModule,
        IdentificationDataModule,
        ContactInformationModule,
        ContactsModule,
        CommunicationsModule,
        GestionModule,
        AdministrativeCentersModule,
        DesactivarCustomerModalModule,
        ModalMailModule,
        DeleteCustomerModalModule,
        DownloadExcelModule,
        ModalOrdersModule
    ],
    declarations: [
        GestionTercerosRegisterComponent
    ],
    exports: [
        GestionTercerosRegisterComponent
    ],
    providers: [
        SmsService,
        EmailService,
        CanBeDeleteService,
        AdjuntarDocumentosService,
        ORCustomerVehicleService
    ]
})
export class GestionTercerosRegisterModule { }
